<template>
  <div class="contents">
    <Title>Video Tool</Title>
    <NuxtLayout />
    <LazyToasts />
    <LazyRouterLoading />
  </div>
</template>
